import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategoryListComponent } from './category-list/category-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { SubCategoryListComponent } from './sub-category-list/sub-category-list.component';
import { SubCategoryQuoteListComponent } from './sub-category-quote-list/sub-category-quote-list.component';
import { NgxPaginationModule } from 'ngx-pagination';

@NgModule({
  declarations: [
    CategoryListComponent,
    SubCategoryListComponent,
    SubCategoryQuoteListComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    NgxPaginationModule
  ]
})
export class CategoryModule { }
